import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { AuthService } from './auth/auth.service';
import * as _ from 'lodash';

@Injectable()
export class TokenCommonService {

  constructor(
    protected  http: Http,
    private _authService: AuthService
  ) { }

  private getHeaders(params?: any): RequestOptions {

    const headers = new Headers();
    const token = `Bearer ${ this._authService.getToken() }` ;
    headers.append('Authorization', token);

    if (params) {

      const requestParams = new URLSearchParams();
      const options = new RequestOptions({headers: headers, params: requestParams});

      _.forEach(params, (value, key) => {
        options.params.append(key, value);
      });

      return options;

    } else {
      const options = new RequestOptions({headers: headers});
      return options;
    }
  }

  protected tokenPost (url: string, params?: any) {
    return this.http.post(url, params, this.getHeaders())
      .map(res => {
        return res.json();
      });
  }

  protected tokenPut(url: string, params?: any) {
    if (!params) {
      params = {};
    }
    params._method = 'PUT';
    return this.http.post(url, params, this.getHeaders())
      .map(res => {
        return res.json();
      });
  }

  protected tokenV2Put(url: string, params?: any) {
    return this.http.put(url, params, this.getHeaders())
      .map(res => {
        return res.json();
      });
  }

  protected tokenGet (url: string, params?: any) {
    return this.http.get(url, this.getHeaders(params))
      .map(res => {
        return res.json();
      });
  }

  protected tokenDelete (url: string) {
    return this.http.delete(url, this.getHeaders())
      .map(res => {
        return res.json();
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/token-common.service.ts